import { GameVars } from "./GameVars";
import { Howl } from "howler";
import { GameManager } from "./GameManager";

// audiosprite -e "mp3,ogg" -o ../assets/audio/audiosprite *.mp3 -f howler -b 96

export class AudioManager {

    public static howl: Howl = null;

    private static lastEffectPlayed: string;
    private static loopID: number; 
    private static loopKey: string;
    private static timeLastEffectPlayed: number;

    public static init(): void {

        AudioManager.howl.mute(GameVars.gameData.muted);
        AudioManager.lastEffectPlayed = null;
        AudioManager.loopID = null;
        AudioManager.loopKey = null;
    }

    public static toggleAudioState(): void {

        GameVars.gameData.muted = !GameVars.gameData.muted;
        GameManager.writeGameData();
        
        AudioManager.howl.mute(GameVars.gameData.muted);
    }

    public static mute(): void {

        if (AudioManager.howl === null) {
            return;
        }

        AudioManager.howl.mute(true);
    }

    public static unmute(): void {

        if (AudioManager.howl === null) {
            return;
        }

        if (!GameVars.gameData.muted) {
            AudioManager.howl.mute(false);
        }
    }

    public static playSound(key: string, loop?: boolean, volume?: number, rate?: number): number {

        const t = new Date().getTime();

        if (t - AudioManager.timeLastEffectPlayed < 100 && AudioManager.lastEffectPlayed === key) {
            return;
        }

        if (loop && AudioManager.loopKey === key) {
            return;
        }

        AudioManager.timeLastEffectPlayed = t;
        AudioManager.lastEffectPlayed = key;

        loop = loop || false;
        volume = volume || 1;

        const id = AudioManager.howl.play(key);
        
        AudioManager.howl.volume(volume, id);
          
        if (loop) {

            AudioManager.loopKey = key;

            if (AudioManager.loopID) {
                AudioManager.howl.stop(AudioManager.loopID);
            }

            AudioManager.loopID = id;
            AudioManager.howl.loop(true, AudioManager.loopID);
        }

        if (rate) {
            AudioManager.howl.rate(rate, id);
        }

        return id;
    }

    public static stopSound(id: number): void {

        AudioManager.howl.stop(id);
    }

    public static setLoopVolume(v: number): void {
        
        AudioManager.howl.volume(v);
    }

    public static stopLoop(loopID?: number): void {

        let id = AudioManager.loopID || loopID;

        if (id) {
            AudioManager.howl.fade(1, 0, 1000, id);
        }
    }

    public static onBlur(): void {
        
        if (!GameVars.gameData.muted && AudioManager.howl) {
            AudioManager.howl.mute(true);
        }
    }

    public static onFocus(): void {
        
        if (!GameVars.gameData.muted && AudioManager.howl) {
            AudioManager.howl.mute(false);
        }
    }
}
